<template>
  <Content>
   <Slider></Slider>
  <HomePageSections></HomePageSections>
  <AboutIranPhonics/>
  <LearningFeatures></LearningFeatures>

  <!-- <OurTeamSlider></OurTeamSlider> -->
  <footerAdmin></footerAdmin>
   
  </Content>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Content from "@/components/AdminContent.vue";
import Slider from "@/components/Slider.vue";
import HomePageSections from "@/components/HomePageSections.vue";
import footerAdmin from "@/components/AdminFooter.vue";
import AboutIranPhonics from "@/components/AboutIranPhonics.vue";
// import OurTeamSlider from "@/components/OurTeamSlider.vue";
import LearningFeatures from "@/components/LearningFeatures.vue";



// import { lang } from "@/plugins/lang";
// import api from "@/plugins/axios";
import { showLoading, hideLoading } from "@/stores/loading";

// import enText from "@/locales/en/AdminDashboard";
// import faText from "@/locales/fa/AdminDashboard";

// const translations = {
//   en: enText,
//   fa: faText,
// };

// const currentLang = computed(() => translations[lang.value]);
const loading = ref(true);

const fetchData = async () => {
  try {
    loading.value = true;
    showLoading();
  } catch (error) {
    loading.value = false;
  } finally {
    loading.value = false;
    hideLoading();
  }
};

onMounted(fetchData);
</script>

<style scoped>
.custom-slider {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.slider-image {
  width: 100%;
  height: 220px;
  object-fit: cover;
}

@media (min-width: 576px) {
  .slider-image {
    height: 300px;
  }
}

@media (min-width: 768px) {
  .slider-image {
    height: 400px;
  }
}

@media (min-width: 1200px) {
  .slider-image {
    height: 500px;
  }
}
</style>
